import { Navigate, useParams } from 'react-router-dom';

/** Legacy route: redirect to inline shop mode on the project page. */
function ShopTheLookPage() {
  const { projectId } = useParams();
  if (!projectId) {
    return <Navigate to="/projects" replace />;
  }
  return <Navigate to={`/projects/${projectId}?shop=1`} replace />;
}

export default ShopTheLookPage;
